import React, { useState, useEffect} from 'react';
import { Link } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

const Home = () => {

    const [version, setVersion] = useState("");
    
    useEffect(() => {
        fetch("/version.txt")
        .then(response => response.text())
        .then(text => setVersion(text.trim()));
    }, []);

    if (!!sessionStorage.getItem('token')) {
        return <Navigate to="/login" replace />;
    }
    
    return (
        <div className="flex md:flex-row flex-col w-screen h-screen">
            <div className="relative flex justify-around items-center bg-gradient-to-tr from-orange-600 to-orange-400 w-full md:w-1/2 h-2/5 md:h-full overflow-hidden">
                <div>
                    <h1 className="font-sans font-bold text-white text-4xl">SavPlus</h1>
                    <p className="mt-1 text-white">La meilleure gestion de Service Après Vente</p>
                    <Link
                        to="https://savplus-btp.com/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="block bg-white mt-4 mb-2 py-2 rounded-2xl w-28 font-bold text-orange-600 text-center transition hover:translate-y-[-2px] duration-300"
                    >
                        En savoir plus
                    </Link>
                </div>
                <div className="-bottom-32 -left-40 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>
                <div className="-bottom-40 -left-20 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>
                <div className="-top-40 -right-0 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>
                <div className="-top-20 -right-20 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>

                <div className="right-0 bottom-0 absolute">
                    <p className="p-5 px-10 font-bold text-white text-sm" style={{ fontFamily: "'Source Code Pro', monospace" }}>v{version}</p>
                </div>
            </div>
            <div className="flex justify-center items-center bg-white py-10 w-full md:w-1/2 h-2/5 md:h-full">


                <div className="bg-white w-96">
                    <h1 className="mb-8 font-bold text-gray-900 text-xl md:text-2xl text-center leading-none md:tracking-tight tracking-normal">
                        <span className="block lg:inline bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600 py-2 w-full text-transparent leading-12">
                            Notre service après-vente est là pour vous.
                        </span>
                        <span> Connectez-vous pour y acceder !</span>
                    </h1>

                    <div className="flex justify-center items-center space-x-2 mb-4 md:mb-8">
                        <Link
                            to="/login"
                            className="inline-flex justify-center items-center bg-orange-500 mb-2 sm:mb-0 px-6 py-3 rounded-2xl w-full sm:w-auto text-white text-lg"
                        >
                            Connexion
                            <svg className="ml-1 w-4 h-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd"></path>
                            </svg>
                        </Link>
                    </div>

                    <h1 className="mb-8 font-bold text-gray-900 text-xl md:text-2xl text-center leading-none md:tracking-tight tracking-normal">
                        <span>Vous n'avez pas encore de compte ?</span>
                        <span className="block lg:inline bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600 py-2 w-full text-transparent leading-12">
                            Créez un compte.
                        </span>
                    </h1>

                    <div className="flex justify-center items-center space-x-2 mb-4 md:mb-8">
                        <Link
                            className="inline-flex justify-center items-center bg-gray-100 mb-2 sm:mb-0 px-6 py-3 rounded-2xl w-full sm:w-auto text-lg cursor-not-allowed"
                        >
                            S'inscrire
                            <i class="ml-1 fa-plus fa-solid"></i>
                        </Link>
                    </div>

                    <h1 className="mb-8 font-bold text-gray-900 text-xl md:text-2xl text-center leading-none md:tracking-tight tracking-normal">
                        <span>Vous cherchez une assistance ?</span>
                        <span>
                            <a
                                href="mailto:contact@savplus-btp.com"
                                className="block lg:inline bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600 py-2 w-full text-transparent decoration-orange hover:underline leading-12"
                            >
                                contact@savplus-btp.com
                            </a>
                        </span>
                    </h1>

                </div>

            </div>
            <div className="md:hidden relative flex justify-around items-center bg-gradient-to-tr from-orange-600 to-orange-400 w-full md:w-1/2 h-1/5 md:h-full overflow-hidden visible">
                <div className="-bottom-32 -left-40 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>
                <div className="-bottom-40 -left-20 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>
                <div className="-top-40 -right-0 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>
                <div className="-top-20 -right-20 absolute border-4 border-t-8 border-opacity-30 rounded-full w-80 h-80"></div>
            </div>
        </div>
    );
};

export default Home;

<section className="bg-white pt-24 h-screen">
    <div className="mx-auto px-12 max-w-7xl">
        <div className="mx-auto w-full md:w-11/12 xl:w-9/12 text-left md:text-center">
            <h1 className="mb-8 font-extrabold text-gray-900 text-4xl md:text-6xl leading-none md:tracking-tight tracking-normal">
                <span>Start </span>
                <span className="block lg:inline bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600 py-2 w-full text-transparent leading-12">
                    building a buzz
                </span>
                <span> around your product ?</span>
            </h1>
            <p className="mb-8 px-0 lg:px-24 text-gray-600 text-lg md:text-xl">
                Start gaining the traction you've always wanted with our next-level templates and designs. Crafted to help you tell your story.
            </p>

        </div>
        <div className="mx-auto mt-20 w-full md:w-10/12 text-center">
            <div className="z-0 relative mt-8 w-full">
                <div className="relative shadow-2xl overflow-hidden">
                    <div className="flex flex-none items-center bg-orange-400 px-4 rounded-xl rounded-b-none h-11">
                        <div className="flex space-x-1.5">
                            <div className="border-2 border-white rounded-full w-3 h-3"></div>
                            <div className="border-2 border-white rounded-full w-3 h-3"></div>
                            <div className="border-white rounded-full w-3 h-3 bor der-2"></div>
                        </div>
                    </div>
                    <img src="/img/dashboard.png" alt="orange Dashboard" />
                </div>
            </div>
        </div>
    </div>
</section>